import styled from "styled-components";

export const PageTitle = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: left;
    color: #000000;
    margin-bottom: 38px;
`;

export const PageHeader = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  align-items: center;
  color: #000000;
  margin-bottom: 15px;

`;

export const CardTitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 6px;
  padding-top: 8px;
`;

export const CardSubTitle = styled.div`
  font-weight: 400;
  font-size: 13px;
  margin-bottom: 10px;
  line-height: 16px;
`;

export const CardButton = styled.button`
  height: 36px;
  background: #ffffff;
  border: 1px solid #005aa9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100px;
  margin-right: 7px;
  cursor: pointer;
  color: #005AA9;
`;

export const CardButtonFilled = styled.button`
  height: 36px;
  background: #ffffff;
  border: 1px solid #005AA9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100px;
  margin-right: 7px;
  cursor: pointer;
  background: #005AA9;
  color: #fff
`;

export const Card = styled.div`
  display: flex;
  height: 135px;
  margin-top: 30px;
  font-family: Work Sans;
`;

export const OuterCard = styled.div`
  margin-bottom: 60px;
  padding-left: 23px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 75%;
`;
